
<div style="padding: 24px;">
<div class="modal-body" style="padding: 8px 15px 10px 10px !important;">
    <h4 class="modal-title" >{{ data.title }}</h4>

    <p> {{ data.message1 }}</p> 
    <p *ngIf="data.message3"> {{ data.message3 }}</p> 
    <p style="font-weight: 600;"> {{ data.message2 }}</p>
</div>
<div class="modal-footer" style="justify-content: right !important" *ngIf="data.type == 'alert'">
  
    <!-- <button mat-button (click)="decline()" style="margin-right: 10px;">{{ data.cancelbtn }}</button> -->
    <button mat-flat-button color="accent" *ngIf="data.type != 'success'" (click)="dismiss()">{{ data.okbtn }}</button>
 
</div>
<div class="modal-footer" style="justify-content: right !important" *ngIf="data.type == 'confirm'">
  
    <button mat-button (click)="dismiss()" style="margin-right: 10px;">{{ data.cancelbtn }}</button>
    <button mat-flat-button color="accent" *ngIf="data.type != 'success'" (click)="accept()">{{ data.okbtn }}</button>
 
</div>
</div>